'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { dateFormatter } from 'utils/dateFormatter/dateFormatter'

import text from 'fukku/styles/texts.module.scss'

export function SectionUpdateTime({ date }: { readonly date: string }) {
	const { t } = useLabels()
	const {
		country: { locale },
	} = useMasterData()

	const formattedDate = dateFormatter({ dateString: date, locale })

	return (
		<p className={text.bodyS}>
			{`${t('privacy.reviewDate.title')} `}
			<time dateTime={date}>{formattedDate}</time>
		</p>
	)
}
